"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceLabel = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PriceLabel = ({
  title,
  currentPrice,
  cataloguePrice,
  immediateDiscountPriceVisible,
  mrpStatementEnabled,
  oldPriceVisible
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const bestPrice = currentPrice ?? cataloguePrice;
  if (immediateDiscountPriceVisible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      "data-testid": getTestId(_constants.PRICES_CATALOG_PRICE),
      children: [title, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SmallPrice, {
        crossedOut: !oldPriceVisible && mrpStatementEnabled,
        children: bestPrice
      }), oldPriceVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SmallPrice, {
        crossedOut: true,
        shadowColored: true,
        "data-testid": getTestId(_constants.PRICES_CROSSED_CATALOG_PRICE),
        children: cataloguePrice
      }) : null]
    });
  }
  if (oldPriceVisible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      "data-testid": getTestId(_constants.PRICES_CATALOG_PRICE),
      children: [title, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SmallPrice, {
        crossedOut: true,
        "data-testid": getTestId(_constants.PRICES_CROSSED_CATALOG_PRICE),
        children: cataloguePrice
      })]
    });
  }
  return null;
};
exports.PriceLabel = PriceLabel;
